import React from 'react'
import { StyleSheet, Text, View } from 'react-native'
import { colors } from '@lib/colors'
import { i18n } from '@lib/i18n'
import moment from 'moment'

interface WorkOrderInformationProps {
  status?: string
  endDate?: string
}

const COPY = i18n.en.WORK_ORDERS.VIEW

const WorkOrderInformation = ({ status, endDate }: WorkOrderInformationProps) => {

  const estimatedCompletion = () => {
    if (!endDate) return 'N/A'
    return moment(endDate, 'YYYY-DD-MMThh:mm:ss').fromNow()
  }

  return (
    <View style={ styles.informationWrapper }>
      <View style={ styles.informationField }>
        <Text style={ styles.informationFieldHeader }>{ COPY.STATUS }</Text>
        <Text style={ styles.informationFieldValue }>{ status }</Text>
      </View>
      {/* { endDate && ( */}
        <>
          <View style={ styles.separator } />
          <View style={ styles.informationField }>
            <Text style={ styles.informationFieldHeader }>{ COPY.EST_COMPLETION_DATE }</Text>
            <Text style={ styles.informationFieldValue }>{ estimatedCompletion() }</Text>
          </View>
        </>
      {/* )} */}
    </View>
  )
}

export default WorkOrderInformation

const styles = StyleSheet.create({
  informationWrapper: {
    flexDirection: 'row',
  },
  informationField: {
    marginRight: 15,
  },
  informationFieldHeader: {
    fontSize: 11,
    fontWeight: '400',
    color: colors.gray[500],
  },
  informationFieldValue: {
    color: colors.gray[700],
    fontSize: 16,
    fontWeight: '700',
    marginTop: 5,
  },

  separator: {
    alignSelf: 'stretch',
    borderRightColor: colors.gray[700],
    borderRightWidth: StyleSheet.hairlineWidth,
    marginRight: 15,
  },
})
